import React from 'react';
import { Container, Grid } from '@material-ui/core';
import {
  useStyles,
  VoluntaryMarketLogic,
  carbonCreditImg,
  CDRProject,
  adobeStock,
} from './VoluntaryMarket.module';
import Footer from '../footer/Footer';
import BannerInterface from '../shared/bannerInterface/bannerInterface';
import InfoQuestions from '../shared/infoQuestions/infoQuestion';
import MoreInformationDemo from '../MoreInformationDemo/MoreInformationDemo';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

const VoluntaryMarket = () => {
  const classes = useStyles();
  const { translator } = VoluntaryMarketLogic();
  const isMobile = useMediaQuery(useTheme().breakpoints.down('sm'));

  return (
    <>
      <BannerInterface
        backgroundImg={carbonCreditImg}
        bannerTitle={[translator('carbonCredits.title'), translator('')]}
        descriptionTexts={
          isMobile
            ? [translator('carbonCredits.subtitle')]
            : [
                translator('carbonCredits.subtitleOne'),
                translator('carbonCredits.subtitleTwo'),
                translator('carbonCredits.subtitleThree'),
              ]
        }
      />
      <Container>
        <Grid container className={classes.voluntaryMarketContainer}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <InfoQuestions
              textInfo={translator('carbonCreditInfoQuestionsText')}
              src={CDRProject}
              withoutButton={true}
              showOneImg={true}
            />
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <InfoQuestions
              textInfo={translator('carbonCreditInfoQuestionsText2')}
              src={adobeStock}
              type="reverse"
              withoutButton={true}
              showOneImg={true}
            />
          </Grid>
        </Grid>

        <MoreInformationDemo
          key_translator={translator(
            'VoluntaryMarket.carbon_removal_to_develop'
          )}
          go_to="/demoForm"
        />
        <MoreInformationDemo
          key_translator={translator('VoluntaryMarket.for_more_info_and_demo')}
          go_to="/projects"
          buttonText="projects_button"
        />
      </Container>
      <Footer />
    </>
  );
};

export default VoluntaryMarket;
